import { Module } from 'wrapper6';
import PostSlider from "../utils/_post_slider";

export default class Slider extends Module {
    ready(app) {
        new PostSlider();

        let filters = document.getElementsByClassName("filter_slider");
        const LOADER = document.getElementById('loader-overlay');

        for (let i = 0; i < filters.length; i++) {
            let filter = filters[i];
            let origin = filter.getAttribute('data-origin');
            filter.addEventListener('click', function() {

                if(filter.getAttribute('href')){
                    return;
                }

                LOADER.classList.add('show');

                // Set ajax data
                let data = {
                    'action': 'filter_slider',
                    'type': origin,
                    'filter': filter.getAttribute('data-filter'),
                    'value': filter.getAttribute('data-value'),
                };

                // Ajax call
                jQuery.post(main_theme_objects.ajax_url, data, function(response) {
                    document.getElementById(filter.getAttribute('data-target')).innerHTML = response;

                    document.querySelector('.filter_slider[data-origin="'+origin+'"].active').classList.remove('active');
                    filter.classList.add('active');

                    LOADER.classList.remove('show');

                    new PostSlider();
                });

            }, false);
        }

    }
}
